module.exports = __webpack_public_path__ + "2b61ff59c12ac4e4e007e7d25c7aaaf1.svg";